/*@flow*/
/** @jsx jsx */
import { jsx } from '@emotion/core';

function MemberFormAltLink({
  children,
  onClick,
}: {
  children: React$Node,
  onClick: () => any,
}) {
  return (
    <a
      data-testid="MemberFormAltLink"
      href=""
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
      className="small"
    >
      {children}
    </a>
  );
}
export default (MemberFormAltLink: any);
